import { APP_HOST, IS_FR, tr } from '@/lib/i18n';
// Centralized app constants
// This file contains configuration values that are used across multiple components

export const SUPPORT = {
  WHATSAPP_NUMBER: '27617525578',
  WHATSAPP_MESSAGE: tr("Hi! I need help with Obedience Code"),
  EMAIL: IS_FR ? 'support@codeofobedience.com' : 'sarah@codeofobedience.com',
  getWhatsAppUrl: () =>
    `https://wa.me/${SUPPORT.WHATSAPP_NUMBER}?text=${encodeURIComponent(SUPPORT.WHATSAPP_MESSAGE)}`,
} as const;

export const APP_CONFIG = {
  APP_NAME: tr("Obedience Code"),
  APP_TAGLINE: tr("Parenting made easier"),
  APP_DOMAIN: APP_HOST,
  APP_URL: `https://${APP_HOST}`,
} as const;
